import { type DeviceSettings } from "@ca.vmedia.tv/domains";
import { useNuxtApp } from '#app';
import type { ExposeInterface } from './types';
import type { AxiosError } from 'axios';
import { Logger } from '@/utils';

export const useDeviceSettingsStore = defineStore('DeviceSettings', (): ExposeInterface => {
    const { $domains } = useNuxtApp();
    const _settings: Ref<DeviceSettings | null> = ref(null);
    const _setupSettingsPromise: Ref<Promise<void> | null> = ref(null);

    const getSettings = computed((): DeviceSettings | null => {
        return _settings.value;
    });

    const _loadSettings = async (): Promise<void> => {
        try {
            _settings.value = await $domains.clientRepository.getDeviceSettings();
        } catch (error) {
            Logger.captureError(error as AxiosError | Error);
        } finally {
            _setupSettingsPromise.value = null;
        }
    };

    const setupSettings = async (force: boolean = false): Promise<void> => {
        if (!force && _settings.value !== null) {
            return;
        }

        if (_setupSettingsPromise.value !== null) {
            return _setupSettingsPromise.value;
        }

        _setupSettingsPromise.value = _loadSettings();
        return _setupSettingsPromise.value;
    };

    return {
        getSettings,
        setupSettings,
    };
});